import PropTypes from 'prop-types';
import { Tooltip, Chip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import WarningIcon from '@mui/icons-material/Warning';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const statusConfig = {
  VERIFIED: {
    label: 'Verified',
    color: 'success',
    icon: <VerifiedIcon fontSize="small" />,
    tooltip: 'Integrity verified — hash chain is valid',
  },
  FAILED: {
    label: 'Failed',
    color: 'error',
    icon: <WarningIcon fontSize="small" />,
    tooltip: 'Integrity check failed — hash mismatch detected',
  },
  PENDING: {
    label: 'Pending',
    color: 'warning',
    icon: <HelpOutlineIcon fontSize="small" />,
    tooltip: 'Integrity verification pending',
  },
  LEGACY: {
    label: 'Unverified',
    color: 'default',
    icon: <HelpOutlineIcon fontSize="small" />,
    tooltip: 'Recorded before integrity verification was available',
  },
};

export default function IntegrityBadge({ status }) {
  const config = statusConfig[status] || statusConfig.LEGACY;

  return (
    <Tooltip title={config.tooltip} arrow>
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    </Tooltip>
  );
}

IntegrityBadge.propTypes = {
  status: PropTypes.oneOf(['VERIFIED', 'FAILED', 'PENDING', 'LEGACY']),
};
